// Mirrors pruneTaskRunsArgsSchema in packages/middleware/src/task/tasks/
// prune-task-runs.runner.ts — keep the range and default in sync.
export const MIN_DAYS = 30
export const MAX_DAYS = 365
export const DEFAULT_DAYS = 90

export function extractRetainDays(value: unknown): unknown {
  if (typeof value === 'object' && value !== null && 'retain_days' in value) {
    return (value as Record<string, unknown>).retain_days
  }
  return undefined
}

export function validatePruneTaskRunsArgs(value: unknown): string | null {
  const days = extractRetainDays(value)
  if (typeof days !== 'number' || !Number.isInteger(days)) {
    return 'Retain days must be a whole number'
  }
  if (days < MIN_DAYS || days > MAX_DAYS) {
    return `Retain days must be between ${MIN_DAYS} and ${MAX_DAYS}`
  }
  return null
}
